import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-nav', 'search', 'Otsing');
Labels.set('ui-nav', 'searchOpen', 'Ava otsingu vorm');
Labels.set('ui-nav', 'searchClose', 'Sulge otsingu vorm');
